import { ConfigService } from "./config-service";

/**
 * 
 * @param configService
 * @returns
 */
export function configFactory (configService: ConfigService)  {
  return () => configService.loadConfig();
};

/** Class to read environment config dynamically from module */
export class ConfigFactoryProvider {

  public static getConfigFactory(key: string) {
    return (configService: ConfigService) => {
      return configService.getConfig(key);
    };
  }
}
